import { Link } from "react-router-dom";
import { Check, ArrowLeft, Sparkles } from "lucide-react";

const PLANS = [
  {
    id: "free",
    label: "Explorer Free",
    price: "₹0",
    subtitle: "Great to get started",
    accent: "#13A699",
    highlight: false,
    features: [
      "Browse all mentors (contact hidden)",
      "Book classes",
      "Pay through app",
      "View first 2 reviews per mentor",
    ],
    missing: [
      "Full mentor reviews",
      "Priority customer support",
      "Early access to new mentors",
      "Family calendar",
      "Class reminders",
      "Partner brand discounts",
    ],
  },
  {
    id: "plus_monthly",
    label: "Explorer Plus",
    price: "₹299",
    unit: "/ month",
    subtitle: "Most popular",
    accent: "#F97316",
    highlight: true,
    features: [
      "Browse all mentors",
      "Book classes",
      "Pay through app",
      "View all mentor reviews",
      "Priority customer support",
      "Early access to new mentors",
      "Family calendar",
      "Class reminders",
      "Discounts from partner brands (coming soon)",
    ],
  },
  {
    id: "plus_yearly",
    label: "Explorer Plus (Yearly)",
    price: "₹2999",
    unit: "/ year",
    subtitle: "Save ₹589 vs monthly",
    accent: "#8B5CF6",
    highlight: false,
    features: [
      "Everything in Plus",
      "16% cheaper than monthly",
      "Locked-in price for 12 months",
      "One payment, no monthly reminders",
    ],
  },
];

export default function Pricing() {
  return (
    <div className="min-h-screen py-10 px-4" style={{ background: "#FFF7ED" }} data-testid="pricing-page">
      <div className="max-w-5xl mx-auto">
        <Link
          to="/home"
          className="inline-flex items-center gap-1.5 text-sm font-bold mb-6"
          style={{ color: "#13A699" }}
          data-testid="pricing-back-link"
        >
          <ArrowLeft className="h-4 w-4" /> Back to home
        </Link>

        <div className="text-center max-w-2xl mx-auto">
          <h1
            className="font-display text-4xl sm:text-5xl font-bold uppercase"
            style={{ color: "#13A699" }}
            data-testid="pricing-title"
          >
            Explorer Plans
          </h1>
          <p className="mt-3 text-sm" style={{ color: "#13A699BB" }}>
            Start free. Upgrade to Explorer Plus anytime to unlock every mentor review, priority support, and more.
            Cancel from your dashboard anytime.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-4 mt-10">
          {PLANS.map((p) => (
            <div
              key={p.id}
              className="rounded-3xl p-5 sm:p-6 border-2 flex flex-col relative"
              style={{
                borderColor: p.highlight ? p.accent : "#13A69922",
                background: "#fff",
                boxShadow: p.highlight ? "0 12px 24px -12px rgba(249, 115, 22, 0.35)" : "none",
              }}
              data-testid={`pricing-card-${p.id}`}
            >
              {p.highlight && (
                <span
                  className="absolute -top-3 left-1/2 -translate-x-1/2 text-[10px] font-bold uppercase px-3 py-1 rounded-full inline-flex items-center gap-1"
                  style={{ background: p.accent, color: "#FFF7ED" }}
                >
                  <Sparkles className="h-3 w-3" /> Popular
                </span>
              )}
              <h2 className="font-display font-bold text-lg" style={{ color: p.accent }}>{p.label}</h2>
              <p className="text-xs mt-0.5" style={{ color: "#13A69999" }}>{p.subtitle}</p>
              <div className="mt-4 flex items-baseline gap-1">
                <span className="text-4xl font-black" style={{ color: "#13A699" }}>{p.price}</span>
                {p.unit && <span className="text-xs font-bold" style={{ color: "#13A69988" }}>{p.unit}</span>}
              </div>

              <ul className="mt-5 space-y-2 flex-1">
                {p.features.map((f) => (
                  <li key={f} className="flex items-start gap-2 text-sm" style={{ color: "#13A699" }}>
                    <Check className="h-4 w-4 mt-0.5 shrink-0" style={{ color: p.accent }} />
                    <span>{f}</span>
                  </li>
                ))}
                {(p.missing || []).map((f) => (
                  <li key={f} className="flex items-start gap-2 text-sm line-through" style={{ color: "#13A69955" }}>
                    <span className="inline-block h-4 w-4 mt-0.5 shrink-0" />
                    <span>{f}</span>
                  </li>
                ))}
              </ul>

              <Link
                to={p.id === "free" ? "/signup?role=parent" : `/signup?role=parent&plan=${p.id}`}
                className="mt-6 w-full inline-flex items-center justify-center px-4 py-3 rounded-full font-bold text-sm transition"
                style={{
                  background: p.highlight ? p.accent : "#13A699",
                  color: "#FFF7ED",
                }}
                data-testid={`pricing-cta-${p.id}`}
              >
                {p.id === "free" ? "Start free" : "Upgrade to Plus"}
              </Link>
            </div>
          ))}
        </div>

        <p className="mt-8 text-center text-xs" style={{ color: "#13A69988" }}>
          All prices in INR, inclusive of applicable taxes. Payments processed securely via Razorpay.
          Read our <Link to="/terms" className="underline">Terms</Link> and <Link to="/privacy" className="underline">Privacy Policy</Link>.
        </p>
      </div>
    </div>
  );
}
